import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import PlaySvg from 'src/components/svg/PlaySvg';
import type { MovieClip } from 'src/lib/movieinfo/movieinfotypes';
import styles from './RelatedClip.module.css';

//#region [Props]
type RelatedClipProps = {
  clip: MovieClip;
  onClick: () => void;
  className?: string;
};
//#endregion

//#region [Component]
export default function RelatedClip(t0) {
  const $ = _c(15);
  const {
    clip,
    onClick,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.SRelatedClip, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== clip.clipTitle || $[3] !== clip.sanityImageWideUrl) {
    t2 = clip.sanityImageWideUrl && <CmsImageForUrl className={styles.SImage} imageUrl={clip.sanityImageWideUrl} width={200} alt={clip.clipTitle} applyAspectRatio={true} nonPosterAspect={1.7777777777777777} crop={true} />;
    $[2] = clip.clipTitle;
    $[3] = clip.sanityImageWideUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PlaySvg className={styles.SPlaySvg} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className={styles.SImageSizer}>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== clip.clipTitle) {
    t5 = <h2 className={styles.SClipTitle}>{clip.clipTitle}</h2>;
    $[8] = clip.clipTitle;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onClick || $[11] !== t1 || $[12] !== t4 || $[13] !== t5) {
    t6 = <article className={t1} onClick={onClick}>{t4}{t5}</article>;
    $[10] = onClick;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
//#endregion